var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { gql } from '@apollo/client';
import { PageName } from '@amzn/atoz-shiftapp-initializer';
import { useLocationEligibilityPageQuery } from '@amzn/atoz-shiftapp-types';
import { PageSpinner } from '../../features/shared';
import { usePageMetrics } from '../../hooks';
import { GenericErrorPageLayout } from '../GenericErrorPage';
import { LocationEligibilityFeature } from '../../features/LocationEligibility';
import { LocationEligibilityPageLayout } from '.';
import { PageHeader } from '../../features/shared/PageHeader';
import { useTranslation } from 'react-i18next';
export var LocationEligibilityPage = function () {
    var _a = useLocationEligibilityPageQuery(), data = _a.data, loading = _a.loading, error = _a.error, refetch = _a.refetch;
    var t = useTranslation().t;
    usePageMetrics({
        pageName: PageName.LocationEligibility,
        logCf: !loading && !!data
    });
    if (error) {
        return (React.createElement(GenericErrorPageLayout, { textAlign: "center", buttonAction: refetch }));
    }
    if (loading) {
        return (React.createElement(PageSpinner, { dataTestId: "LocationEligibilityPageLoadingSpinner" }));
    }
    var _b = data, siteEligibilities = _b.siteEligibilities, currentWeekProgress = _b.currentWeekProgress;
    var pageHeader = (React.createElement(PageHeader, { headingText: t('shift_management_features_locationEligibility_pageTitle') }));
    return (React.createElement(LocationEligibilityPageLayout, { pageHeader: pageHeader, locationEligibilityFeature: React.createElement(LocationEligibilityFeature, { siteEligibilities: (siteEligibilities === null || siteEligibilities === void 0 ? void 0 : siteEligibilities.siteEligibilities) || [], currentWeekProgress: currentWeekProgress || null }) }));
};
LocationEligibilityPage.QUERY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query LocationEligibilityPage {\n        currentWeekProgress {\n            ...LocationEligibilityFeature_WeekProgress\n        }\n\n        siteEligibilities {\n            ...LocationEligibilityFeature_SiteEligibilities\n        }\n    }\n\n    ", "\n    ", "\n"], ["\n    query LocationEligibilityPage {\n        currentWeekProgress {\n            ...LocationEligibilityFeature_WeekProgress\n        }\n\n        siteEligibilities {\n            ...LocationEligibilityFeature_SiteEligibilities\n        }\n    }\n\n    ", "\n    ", "\n"])), LocationEligibilityFeature.fragments.currentWeekProgress, LocationEligibilityFeature.fragments.siteEligibilities);
var templateObject_1;
